

import { defineComponent } from 'vue';
import { NForm, NInput, NInputNumber, FormRules, NAlert, NColorPicker, NFormItemGi, NGrid } from 'naive-ui';
import { mapStores } from 'pinia';

import { Station } from '~/api/models/station.model';


import ModalBase from '~/components/modals/modal-base';
import Modal from '~/components/modals/modal.vue';
import AQMap from '~/components/map/aqmap.vue';
import { FeatureCollection } from 'geojson';
import { useStationStore } from '~/store/station.store';

export default defineComponent({

    extends: ModalBase,

    components: {
        AQMap,
        Modal,
        NForm,
        NFormItemGi,
        NInput,
        NInputNumber,
        NAlert,
        NColorPicker,
        NGrid,
    },

    data() {
        const result = { name: '', room: '', city: '', lat: null, lon: null, color: null };
        return {
            stationToUpdate: null as Station,
            mapStation: null as Station,
            promise: null as (value: Promise<Partial<Station>>) => void,
            valid: true,
            pristine: true,
            failed: false,

            autoCompleteOptions: [] as { label: string, value: string }[],

            result,
            rules: {
                name: { required: true, trigger: 'blur', message: ' ' },
                city: { required: true, trigger: 'blur', message: ' ' },
                room: { required: true, trigger: 'blur', message: ' ' },
                lat: { required: true, trigger: 'blur', type: 'number', message: ' ' },
                lon: { required: true, trigger: 'blur', type: 'number', message: ' ' },
                color: { requried: false }
            } as FormRules,
        }
    },

    computed: {
        ...mapStores(useStationStore),
    },

    methods: {

        onMapClick({ lat, lng }: { lat: number, lng: number }): void {
            this.result.lat = lat;
            this.result.lon = lng;
            this.mapStation = { ...this.mapStation, location: { lat, lon: lng } }
            this.$photonService.searchByLocation(lat, lng).then((result: FeatureCollection) => {
                this.result.city = result?.features && result.features.length && result.features[0].properties.city
            })
        },

        editStation(station: Station): void {
            this.stationToUpdate = this.mapStation = { ...station };
            this.result = {
                name: this.getStationName(station),
                room: station.metadata['elichens/public/location'] || '',
                city: station.metadata['elichens/public/locality'] || '',
                lat: station.location?.lat || null,
                lon: station.location?.lon || null,
                color: station.metadata['elichens/public/color']
            }
            this.open();
        },

        async submit(): Promise<void> {

            if (!this.valid) {
                return;
            }

            const station: Partial<Station> = {
                location: {
                    lat: this.result.lat,
                    lon: this.result.lon,
                },
                metadata: {
                    "elichens/public/label": this.result.name,
                    "elichens/public/locality": this.result.city,
                    "elichens/public/location": this.result.room,
                    "elichens/public/color": this.result.color,
                }
            }
            this.failed = false;
            await this.stationStore.updateStation(this.stationToUpdate.id, station)
                .then(() => {
                    this.close(true);
                    this.$emit('station:edit', { ...this.stationToUpdate, ...station});
                })
                .catch(() => {
                    this.failed = true;
                })
        },
    },

    watch: {
        result: {
            handler() {

                this.pristine = false;
                //@ts-ignore
                this.$refs?.formInst?.validate()
                    .then(() => this.valid = true)
                    .catch((err: Error) => {
                        if (err) {
                                this.valid = false;
                        }
                    });
            },
            deep: true,
        }
    }
});
